import { css } from "@linaria/core";

import { pm2Boundaries } from "@pm2/design-tokens";
import { breakpoints, units } from "@ui/css";
import { colors, surfaces, typographies } from "@ui/kit/design-tokens";
import { postloadedImageSelectors } from "@utils/react/selectors";

export const section = css`
  position: relative;

  overflow: hidden;

  display: flex;
  align-items: flex-start;
  gap: ${units.px(30)} ${units.px(55)};

  &[data-with-background="true"] {
    margin-inline: ${pm2Boundaries.container.offsetLeft({ scale: -1 })}
      ${pm2Boundaries.container.offsetRight({ scale: -1 })};
    padding-inline: ${pm2Boundaries.container.offsetLeft()}
      ${pm2Boundaries.container.offsetRight()};
    padding-top: ${units.px(60)};
    padding-bottom: ${units.px(105)};

    background: ${surfaces.primary({ alpha: 0.9 })};

    @media ${breakpoints.mobile.andDown().toQuery()} {
      padding-top: ${units.px(40)};
      padding-bottom: ${units.px(65)};
    }
  }

  &[data-with-background="false"] {
    padding-top: ${units.px(40)};
  }

  @media ${breakpoints.mobile.andDown().toQuery()} {
    flex-direction: column;
  }
`;

export const imageWrapper = css`
  position: relative;
  flex-basis: 50%;

  @media ${breakpoints.mobile.andDown().toQuery()} {
    width: 100%;
    order: 2;
  }
`;

export const image = css`
  & ${postloadedImageSelectors.image()} {
    height: auto;
    border-radius: ${units.px(4)};
  }
`;

export const creditLine = css`
  position: absolute;
  right: ${units.px(10)};
  bottom: ${units.px(10)};
  z-index: 2;

  height: ${units.px(25)};
  width: ${units.px(25)};

  background-color: ${colors.black({ alpha: 0.1 })};
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  color: #fff;

  transition: background-color 0.1s linear;

  &:hover {
    background-color: ${colors.black({ alpha: 0.9 })};
  }
`;

export const content = css`
  max-width: ${units.px(700)};
  flex-basis: 50%;
`;

export const label = css`
  margin-top: ${units.px(-3)};
  margin-bottom: ${units.px(5)};

  font-family: ${typographies.meta()};
`;

export const heading = css`
  overflow-wrap: anywhere;
  hyphens: auto;

  font-family: ${typographies.heading1()};
  text-wrap: pretty;
`;

export const body = css`
  margin-block: ${units.px(20)};

  ${colors.selectors.primary.isDark()} .${section}[data-with-background="true"] & {
    ${colors.interactiveText.link
      .__override({
        default: surfaces.primary.default.color,
        hover: surfaces.primary.default.color,
        active: surfaces.primary.default.color,
      })
      .toString()};
  }

  @media ${breakpoints.mobile.andDown().toQuery()} {
    margin-top: 0;
  }
`;

export const mobileContent = css`
  order: 3;
`;

export const backdrop = css`
  position: absolute;
  inset: 0;
  z-index: -1;

  filter: blur(18px);
`;

export const graphic = css`
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;

  color: #fff;
`;
